/**
 * Error URN constants used as the `type` field of RFC 7807 Problem Details.
 *
 * Clients MUST branch on these URNs rather than HTTP status alone (per D-15).
 * Keep this list aligned with `packages/api/src/middleware/errorHandler.ts`
 * and any new error classes introduced by future plans.
 */

export const URN_VALIDATION = 'urn:clearroute:error:validation'
export const URN_INTERNAL = 'urn:clearroute:error:internal'
export const URN_HTTP = 'urn:clearroute:error:http'
export const URN_AUTH_INVALID_TOKEN = 'urn:clearroute:error:auth.invalid-token'
export const URN_AUTH_RATE_LIMITED = 'urn:clearroute:error:auth.rate-limited'
export const URN_QUOTA_BUDGET = 'urn:clearroute:error:quota.daily-budget'
export const URN_TOMTOM_UPSTREAM = 'urn:clearroute:error:tomtom.upstream'

export type ErrorUrn =
  | typeof URN_VALIDATION
  | typeof URN_INTERNAL
  | typeof URN_HTTP
  | typeof URN_AUTH_INVALID_TOKEN
  | typeof URN_AUTH_RATE_LIMITED
  | typeof URN_QUOTA_BUDGET
  | typeof URN_TOMTOM_UPSTREAM
